module.exports = __webpack_public_path__ + "static/media/YM63_0.4d10c0de.jpg";